import { Navigate } from "react-router-dom";
import { useAppSelector } from "../ReduxToolkit/Hooks";

const RedirectRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return !isAuthenticated ? <Navigate to={`${process.env.PUBLIC_URL}/login`} /> : <>{children}</>;
};

export default RedirectRoute;
